/* eslint-disable jsx-a11y/interactive-supports-focus */
import React, { useEffect, useRef, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { logo } from '../../../../configs/Icons';
import { useInit } from '../../../Contexts/InitProvider';
import { DownArrowIcon } from '../../../utils/SVGIcon';
import { getParentPath } from '../../../utils/URL';
import cn from '../../../utils/cn';
import { useMenus } from '../MenuProvider';
import ColorMode from '../WebHeader/Components/ColorMode';

function ImgHoverTag({ imgFill, imgLine }) {
    return (
        <span className="double-img-hover inline-block relative h-5.5 w-5.5">
            <img
                src={imgFill}
                alt=""
                className="absolute w-full top-0 left-0 opacity-0 group-hover/link:opacity-100"
            />
            <img
                src={imgLine}
                alt=""
                className="absolute w-full top-0 left-0 opacity-100 group-hover/link:opacity-0"
            />
        </span>
    );
}

function SubMenuItem({ subMenu = [], isActive = false, setMenuOpen }) {
    return (
        <ul
            className={`submenu-level-2 ml-5 transition-all pl-0.5 overflow-hidden duration-${
                subMenu?.length
            }00 ${isActive ? `max-h-40` : 'max-h-0'} `}
        >
            {subMenu?.map((item) => (
                <li key={item?.id} className="flex items-center mb-1 mt-1 -ml-px relative -z-0">
                    <div className="line-vh h-12 absolute w-4 -top-7 left-0 bg-transparent border border-t-0 border-r-0 border-secondary-200 rounded-bl-md" />
                    <NavLink
                        onClick={() => setMenuOpen(false)}
                        to={`/${item.path}`}
                        className={cn(
                            'py-[7px] px-2.5 ml-4 hover:bg-secondary-100 w-full rounded-md transition-colors',
                            {
                                'bg-secondary-100': item.path === window.location.pathname
                            }
                        )}
                    >
                        <span className="text-base font-normal capitalize text-primary-700">
                            {item.title}
                        </span>
                    </NavLink>
                </li>
            ))}
        </ul>
    );
}
function MobileSidebarMenuPage({ links = [] }) {
    const { menuOpen, setMenuOpen } = useMenus();
    const [itemId, setItemId] = useState(0);

    const { initInfo } = useInit();

    const ref = useRef();
    // Remove menu when click outside
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                setMenuOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [setMenuOpen]);

    const handleShowMenu = (e, item) => {
        if (item.subMenu) {
            e.preventDefault();
        }
        if (!item.subMenu) {
            setMenuOpen(false);
        }
        if (itemId === item.id) {
            setItemId(0);
        } else {
            setItemId(item.id);
        }
    };

    return (
        <div
            className={`bg-primary/20 w-full fixed top-0 z-50 transition duration-500 ${
                menuOpen ? 'translate-x-0 ' : '-translate-x-full '
            }`}
        >
            <ul
                ref={ref}
                className="submenu-level-1 w-4/5 bg-white border-r border-primary-100 h-screen transition-all duration-300 overflow-hidden p-4 pl-2.5 overflow-y-auto scrollbar scrollbar-track-transparent scrollbar-thumb-secondary-200 scrollbar-thumb-rounded-md scrollbar-w-[5px] min-w-[272px]"
            >
                <div className="flex justify-between items-center mb-4">
                    <div className="w-30 flex items-center justify-center ">
                        <img
                            src={initInfo?.adminLogo || logo.mainLogoW}
                            alt=""
                            className="w-full block"
                        />
                    </div>
                    <ColorMode onClick={null} />
                </div>
                {links?.map((item) => (
                    <li key={item?.id} className="mb-1">
                        <NavLink
                            to={item.path}
                            onClick={(e) => handleShowMenu(e, item)}
                            className={`group/link w-full flex  justify-center items-center gap-2 py-[7px] px-2.5 bg-white hover:bg-secondary text-primary-700 hover:text-white-100 rounded-md transition relative z-20 ${
                                getParentPath(item.path) === window.location.pathname
                                    ? 'active'
                                    : ''
                            }`}
                        >
                            <div className="flex flex-row items-center w-full gap-4">
                                <ImgHoverTag imgFill={item.iconWF} imgLine={item.iconWL} />
                                <span className="text-base font-normal capitalize">
                                    {item.title}
                                </span>
                            </div>
                            {item?.subMenu && (
                                <span
                                    role="button"
                                    className={`inline-block w-4 h-4 ${
                                        item?.id === itemId ||
                                        getParentPath(item?.path) ===
                                            window?.location?.pathname.split('/')[1]
                                            ? 'rotate-180'
                                            : 'rotate-0'
                                    }`}
                                >
                                    <DownArrowIcon />
                                </span>
                            )}
                        </NavLink>

                        {item?.subMenu && (
                            <SubMenuItem
                                subMenu={item?.subMenu}
                                isActive={
                                    item?.id === itemId ||
                                    getParentPath(item.path) ===
                                        window?.location?.pathname.split('/')[1]
                                }
                                setMenuOpen={setMenuOpen}
                            />
                        )}
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default MobileSidebarMenuPage;
